import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconRubRoundNotDefined.tsx
const IconRubRoundNotDefined = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 32 32",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsxs("g", {
		fill: "currentColor",
		children: [/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			d: "M28.956 14.669c0-7.365-5.97-13.335-13.335-13.335S2.286 7.304 2.286 14.669s5.97 13.335 13.335 13.335q1.015 0 1.991-.148A8.555 8.555 0 0 1 28.808 16.66q.147-.975.148-1.991m-16.18-.182V8.52h4.74q1.46 0 2.473.528 1.014.522 1.535 1.418.529.89.529 2 0 1.155-.535 2.032-.534.872-1.547 1.37-1.012.49-2.455.49h-2.468v.934h2.757v1.871h-2.757v1.928h-2.272v-1.928H10.93v-1.871h1.847v-.934H10.93v-1.872z",
			clipRule: "evenodd"
		}), /* @__PURE__ */ jsx("path", { d: "M17.516 10.411q.768 0 1.264.276.503.27.749.743.252.467.246 1.056.006.6-.246 1.05a1.67 1.67 0 0 1-.761.699q-.51.252-1.301.252h-2.419V10.41zM23.835 26.77v-.278q0-.956.15-1.524.15-.57.444-.91.294-.348.72-.627.369-.243.657-.47a2 2 0 0 0 .461-.48 1 1 0 0 0 .173-.58.94.94 0 0 0-.138-.51.94.94 0 0 0-.375-.342 1.1 1.1 0 0 0-.524-.122q-.312 0-.576.145-.26.145-.421.4-.156.255-.156.591H21.3q.01-1.275.576-2.07a3.27 3.27 0 0 1 1.498-1.17 5.4 5.4 0 0 1 2.052-.377q1.233 0 2.202.365.967.36 1.527 1.09.56.725.56 1.814 0 .702-.243 1.235a2.9 2.9 0 0 1-.663.934q-.42.4-.985.73-.416.243-.698.504-.282.255-.426.586-.144.325-.144.788v.278zm1.407 3.896a1.58 1.58 0 0 1-1.147-.47 1.56 1.56 0 0 1-.467-1.153q-.007-.66.467-1.13a1.58 1.58 0 0 1 1.147-.47q.633 0 1.118.47.49.47.495 1.13a1.57 1.57 0 0 1-.236.823q-.225.366-.588.586a1.5 1.5 0 0 1-.79.214" })]
	})]
});
var IconRubRoundNotDefined_default = forwardRef(IconRubRoundNotDefined);
//#endregion
export { IconRubRoundNotDefined_default as default };
